import React from 'react'
import GoogleLogin from 'react-google-login'
import { useDispatch } from 'react-redux'
import { signUpWithGoogle, signInWithGoogle } from 'actions/auth'
import { makeStyles } from '@material-ui/core/styles'
import PropTypes from 'prop-types'

const useStyles = makeStyles((theme) => ({
  button: {
    width: '100%',
    marginBottom: theme.spacing(2)
  }
}))

const GoogleAuthenticate = ({ type = 'signIn', communityId, onSuccessCallback }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const handleGoogleLogin = (googleUser) => {
    const idToken = googleUser.getAuthResponse().id_token
    dispatch(type === 'signUp' ? signUpWithGoogle(idToken, communityId) : signInWithGoogle(idToken)).then(() => {
      onSuccessCallback()
    })
  }

  return (
    <GoogleLogin
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID}
      buttonText={`${type === 'signUp' ? 'Sign Up' : 'Sign In'} with Google`}
      theme='dark'
      onSuccess={handleGoogleLogin}
      onFailure={(error) => console.log(error)}
      cookiePolicy={'single_host_origin'}
      className={classes.button}
    />
  )
}

GoogleAuthenticate.propTypes = {
  type: PropTypes.string,
  communityId: PropTypes.string,
  onSuccessCallback: PropTypes.func.isRequired
}

export default GoogleAuthenticate
